import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles((theme) => ({
  root: {
    flexBasis: "100%",
    height: "100%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    background: "#EEF2F4",
  },
  content: {
    marginLeft: "5%",
    background: "transparent",
  },
  image: {
    width: "100%",
    height: "50%",
  },
  title: {
    margin: "1.5rem 0 2.5rem 0",
    backgroundColor: theme.palette.primary.main,
  },
  details: {
    marginBottom: "1.6rem",
  },
  button: {
    textTransform: "none",
    paddingRight: "5rem",
    marginBottom: theme.spacing(1.5),
  },
}));

export default function BlogImageCard() {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <Skeleton variant="rect" className={classes.image} />
      <CardContent className={classes.content}>
        <Box width="90%">
          {/* Date text */}
          <Skeleton variant="text" width="15%" />
          {/* Title text */}
          <Skeleton variant="text" width="35%" className={classes.title} />
          {/* Details text */}
          <Skeleton variant="text" />
          <Skeleton variant="text" />
          <Skeleton variant="text" />
          <Skeleton variant="text" />
        </Box>
      </CardContent>
    </Card>
  );
}
